
export type INpmClient = string | 'npm' | 'yarn' | 'lerna';
